<template>
	<div>
		<box :ref="boxRef" title="子订单" :width="1000" :index="0" @hide="hide" @submit="submit"
			moduleName="customerModuleChildrenorder" group="saleorder_goods" :store="store" selectType="checkbox"
			@boxdataload="boxdataload" :footerButton="['submit']" />

	</div>
</template>
<style scoped>
	/* 	.footer_button {
		position: relative;
		width: 100%;
		flex-direction: row;
		align-items: flex-end;
		justify-content: flex-end;
		margin-top: 10px;
	} */
</style>
<script>
	//https://detail.tmall.com/item.htm?id=706822484836&spm=a21dvs.23580594.0.0.1d293d0d88sla5 
	import box from '@_system/components/formcomponents/common/box/index.vue'
	export default {
		props: {
			store: {
				type: Object,
				default: () => {
					return {}
				}
			},
			data: {
				type: Array,
				default: () => {
					return []
				}
			}
		},
		data() {
			return {
				index: 0,
				foreingKey: {},
				boxRef: 'box_' + Math.random(),
				box: null
			}
		},
		created() {

		},
		mounted() {
			let box = this.$refs[this.boxRef]
			box.buttonShow = false
			box.checkMethod = ({
				row
			}) => {
				return row.enablenum > 0
			}
			box.getColumns = this.getColumns
			box.initList = this.initList
			box.show = () => {
				box.initList(box)
			}
			this.box = box

		},
		watch: {

		},
		computed: {

		},

		methods: {
			initList(box) {
				let gridOptions = {
					border: true,
					size: 'mini',
					maxHeight: 500,
					columnConfig: {
						isHover: false,
						resizable: true
					},
					rowConfig: {
						isHover: true,
						isCurrent: true
					},
					data: this.data
				}
				gridOptions.params = {
					mode: 'box',
					store: box.store
				}
				gridOptions.columns = box.getColumns()
				gridOptions.checkboxConfig = {
					// labelField: 'salercpt_uid',
					trigger: 'row',
				}

				box.gridOptions = gridOptions

			},
			getColumns() {
				let columns = []
				columns.push({
					type: 'checkbox',
					width: 50,
					field: '',
					title: '',
				},{
					field: 'salercpt_no',
					title: '订单编号',
				}, {
					field: 'realPayment',
					title: '买家实付',
				}, {
					field: 'tp_pay_time',
					title: '付款时间',
					formatter: ({cellValue})=>{
						return window.systemMethods.timestampToDate(cellValue)
					}
				}, {
					field: 'outboundcode',
					title: '出库单号',
				})
				return columns
			},
			boxdataload(e) {
				this.$emit('boxdataload', e)
			},
			submit(e) {
				this.$emit('submit', e)
			},
			hide() {
				this.$emit('back')
			}
		},
		components: {
			box
		}
	}
</script>
